import React from 'react';
import { Box, Heading, Button, VStack, Text, Divider, HStack, Icon } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ViewIcon } from '@chakra-ui/icons';

const MemberDashboard = () => {
  return (
    <Box p={8} maxW="800px" mx="auto" textAlign="center">
      <Text fontSize="lg" color="gray.600" mb={8}>Welcome to Our Bagda Community</Text>
      
      <VStack spacing={6} divider={<Divider />}>
        {/* --- Matrimony Section --- */}
        <VStack spacing={4} align="stretch" w="full">
          <Heading size="md" color="gray.700">Bagda Matrimony</Heading>
          <Button 
            as={Link} 
            to="/matrimony-create" 
            colorScheme="brand" 
            size="lg"
          >
            Create or Update Matrimony Profile
          </Button>
          <Button 
            as={Link} 
            to="/matrimony-profiles" 
            colorScheme="teal" 
            variant="outline" 
            size="lg"
          >
            View Matrimony Profiles
          </Button>
        </VStack>
        <HStack justify="space-between" align="center">
          <Button 
            as={Link} 
            to="/members" 
            colorScheme="teal" 
            leftIcon={<Icon as={ViewIcon} />}
          >
            View Bagda Member List
          </Button>
        </HStack>

        {/* --- Business Section --- */}
        <VStack spacing={4} align="stretch" w="full">
          <Heading size="md" color="gray.700">Bagda Business Networking</Heading>
          <Button 
            as={Link} 
            to="/business-create" 
            colorScheme="purple" 
            size="lg"
          >
            Create or Update Business Profile
          </Button>
          <Button 
            as={Link} 
            to="/businesses" 
            colorScheme="orange" 
            variant="outline" 
            size="lg"
          >
            View Community Businesses
          </Button>
        </VStack>
        <VStack spacing={4} align="stretch" w="full">
          <Heading size="md" color="gray.700">Bagda Influencers</Heading>
        <Button 
            as={Link} 
            to="/influencers/create" 
            colorScheme="brand" 
            
            size="lg"
          >
            Add Influencer Profile
          </Button>
          <Button 
            as={Link} 
            to="/influencers" 
            colorScheme="brand"
            variant="outline"  
            size="lg"
          >
            Bagda Influencer List
          </Button>
          </VStack>
      </VStack>
    </Box>
  );
};

export default MemberDashboard;